import React, { useEffect, useState } from "react";
import { Table } from "antd";
import FETCH from "../../../utils/fetch";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import axios from "axios";
import swal from "sweetalert";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
export const AssetAssignTable = ({rows,data,handleCashModuleCreate,cbFormChange,allLiabilities,attributeValues,}) => {
  const [loading, setLoading] = useState(false);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cachedData, setCachedData] = useState({});
  const [assetsList, setAssetsList] = useState([]);
  const [liabilities, setLiabilities] = useState(allLiabilities);

  const [total, setTotal] = useState(null);
  const [dataSource, setDataSource] = useState(rows);
  const [count, setCount] = useState(rows && rows.length+1);

  const [payOffData, setPayOffData] = useState([]);
  const [dataRes, setDataRes] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [snowball, setSnowball] = useState(null);

  const totalAmountToUse = dataSource &&  dataSource.reduce((sum, item) => {
    return sum + (item["amountUseForGoal"] || 0);
  }, 0);

  const [totalAmount,setTotalAmount]=useState(0);
  const [totalAmountUsed,setTotalAmountUsed]=useState(totalAmountToUse);

 useEffect(()=>{
    setDataSource(rows);
    const amountUsed =rows && Array.isArray(rows)
      ? rows.reduce((acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0), 0)
      : 0;
    const havefromFriends=data && data["Amount Received"] && (data["Amount Received"] && Array.isArray(data["Amount Received"]) ? data["Amount Received"].reduce((acc, curr) => acc + curr, 0) : 0);
    const totalhave=amountUsed+havefromFriends;
    setTotalAmount(totalhave);
  },[rows])

  const handleAdd = async(record) => {
    if (dataSource && dataSource.some(item => item.assetId === record.id)) {
      swal("Info", "This asset has already been added.", "info");
      return;
    }
    let result = record && calculateGoalRequirements(record, data, transformedData);

    const havefromFriends=data && data["Amount Received"] && (data["Amount Received"] && Array.isArray(data["Amount Received"]) ? data["Amount Received"].reduce((acc, curr) => acc + curr, 0) : 0);

    const amountUsed = rows && Array.isArray(rows)
      ? rows.reduce((acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0), 0) + parseFloat(havefromFriends || 0)
        : parseFloat(havefromFriends || 0);
    const goalNeedToday=parseFloat(result.goalNeedToday.replace(/[^0-9.-]+/g,""));
    let totalNeed=totalAmount+parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g,""));
    setTotalAmount(totalNeed);
    // setTotalAmount(
    //   (prevState) => prevState + (parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g,"")) || 0)
    // );
    console.log("totalNeed",goalNeedToday,amountUsed,totalNeed)
    if(goalNeedToday > totalNeed && amountUsed < goalNeedToday){
      let totalFunded=goalNeedToday-totalNeed;
      let totalFundedPercentage=((totalNeed/goalNeedToday)*100).toFixed(2);
      console.log("totalFunded",totalNeed,totalFunded,totalFundedPercentage)
      swal("",`This Goal is ${totalFundedPercentage}% funded.`,"warning");
    }else{
      const moduleName="Cash";
      if(amountUsed > goalNeedToday){
        swal("Oops","Goal Need Already Fulfilled","error");
        console.log("totalNeed in return case")
        return
      }
      else{
        let moduleToCreate= {
          "Name of Asset":record && record["Name of Asset"] ? "Remaining from Sale of " + record["Name of Asset"] : null,
          "Monetary Value": totalNeed-goalNeedToday, //record && record["Monetary Value"] ? +record["Monetary Value"] :0,
          "Cost Basis Date":record["Cost Basis Date"]? record["Cost Basis Date"]: new Date(),
          "Cost Basis": record["Cost Basis"]? +record["Cost Basis"]: 0,
          "Value as of Date":data && data["Goal Date"]? new Date(data["Goal Date"]): new Date(),
          "Date of Sale": data && data["Goal Date"] ? new Date(data["Goal Date"]) : new Date(),
        }
        console.log("moduleToCreate",moduleToCreate)
        handleCashModuleCreate(moduleToCreate);
        // setLoading(true);
        // const moduleNew=await MODULE_API.addAsset(moduleName, {
        //   clientModules: [
        //     moduleToCreate,
        //   ],
        // });
        // setLoading(false);
        swal("Success","Goal Fully Funded!","success");
        
      }
    }
    console.log("record to create", amountUsed,goalNeedToday);
    if(amountUsed < goalNeedToday){
    const Monetary=record && record["Monetary Value"] ? record["Monetary Value"] :0;
    const taxOnRecord=record && record["Taxes"] ? record["Taxes"] :0;
    const netPaid=Monetary-taxOnRecord;
    const amountToUse= result && result.equityForGoal
    ? parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g, "")) >
      goalNeedToday
      ? goalNeedToday - amountUsed
      : parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g, ""))
    : 0;
    const amountToUseinGoal = dataSource && dataSource.reduce((sum, item) => {
      return sum + (item["amountUseForGoal"] || 0);
    }, 0);
    const totalAmountToUse=amountToUse +amountToUseinGoal;
    setTotalAmountUsed(totalAmountToUse);
    console.log("amountToUse",amountToUse,dataSource,amountToUseinGoal,totalAmountToUse,parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g,"")),goalNeedToday)
    const newData = {
      key: count.toString(),
      assetId:record.id,
      priority: count,
      asset: record && record["Name of Asset"] ? record["Name of Asset"] : null,
      "valueOfAssetGoalRate":
        record && record["Monetary Value"]
          ? record["Monetary Value"]
          : null,
      "loanValueGoalDate":
        result && result.loanPayableForAsset
          ? parseFloat(result.loanPayableForAsset.replace(/[^0-9.-]+/g,""))
          : null,
      "amountUseForGoal":
      (goalNeedToday-amountUsed) > (result && (result.equityForGoal ? (parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g,""))) : 0)) ? result && (result.equityForGoal ? (parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g,""))) : 0) : +(goalNeedToday-amountUsed).toFixed(2),
      // "amountUseForGoal":
      // result && result.equityForGoal ? (parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g,"")) > goalNeedToday ? goalNeedToday-amountUsed : parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g,"")) ): 0,
      taxes: record && record["Taxes"] ? record["Taxes"] : null,
      "netAmountAfterTax":
      totalAmountToUse && totalAmountToUse
          ? totalAmountToUse
          : null,
    };
    console.log("newData", newData);
    let dataToSave=[
      newData,
      ...dataSource,
    ];
    setDataSource([...dataSource, newData]);
    console.log("newData222",dataSource,dataToSave)
    setCount(count + 1);
    cbFormChange([...dataSource, newData]);
  }
  };
  const handleDelete = (record) => {
    // const newData = dataSource && dataSource.filter(item => item.asset_id !== record.id);
    let amountToUse=0;
    let totalAmountToUse=totalAmountUsed;

    const matchedData = dataSource && dataSource.find(item => item.assetId === record.id);
    if (matchedData) {
        amountToUse = parseFloat(matchedData.amountUseForGoal) || 0;
        totalAmountToUse=totalAmountToUse-amountToUse;
        // Subtract the amount from totalAmount
        setTotalAmount(prevState => prevState - amountToUse);
        setTotalAmountUsed(prevState => prevState - amountToUse);

    }
    const newData = dataSource && dataSource.map(item => {
      // Adjust the "Amount to use for this goal" for all records
      return {
        ...item,
        "Net after tax applied to goals": (parseFloat(totalAmountToUse) || 0)
      };
    }).filter(item => item.assetId !== record.id);
    setCount(count - 1);
    console.log("totalAmountToUse",totalAmountToUse,newData)
    setDataSource(newData);
    cbFormChange(newData);
    // setTotalAmount(0);
  };
  const getLiabilityList = async (page) => {
    console.log("here in cached data", cachedData, page);
    if (cachedData && cachedData[page]) {
      // Use cached data
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Liabilities and Credit&page=${page}&limit=10&clientId=${ID}`
            : `?module=Liabilities and Credit&page=${page}&limit=10`,
        body: {},
      });
      setLoading(false);

      if (datares && datares.records) {
        // Cache the data for the current page
        setLiabilities(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAssetsList = async (page) => {
    console.log("here in cached data", cachedData, page);
    if (cachedData && cachedData[page]) {
      // Use cached data
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const id = JSON.parse(localStorage.getItem('accessId'))
      let datares = await FETCH.post({
        url: "client-module-service/client-module/illiquid",
        id: userRole === "Financial Advisor Client" ? `?page=${page}&limit=10&clientId=${id}` : `?page=${page}&limit=10`,
        body: {},
      });
      setLoading(false);

      if (datares && datares.records) {
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAssetLoan = async (id) => {
    try {
      setLoading(true);
      let payload = {
        cmId: id,
      };
      // const response = await DEATH_API.fetchAssetLoan(payload);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = "http://192.168.1.11:3000";
      const response = await axios.post(
        `${baseUrl}/fetch/assets/with/loan`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("response", response.data);
      if (response && response.data && response.data.status === 200) {
        let liablityData = response.data.data;
        // setLiabilities([liablityData]);
        swal("Success", response.data.message, "success");
      }
      if (response && response.data && response.data.status === 400) {
        swal("Error", response.data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response.data) {
        swal("Error", error.response.data.message, "error");
      }
      console.error("Error fetching user data:", error);
    }
  };
  // function getMonthsDifference(date1, date2) {
  //   const year1 = date1.getFullYear();
  //   const year2 = date2.getFullYear();
  //   const month1 = date1.getMonth();
  //   const month2 = date2.getMonth();

  //   return (year2 - year1) * 12 + (month2 - month1);
  // }
    function getMonthsDifference(date1, date2) {
    let years = date2.getFullYear() - date1.getFullYear();
    let months = date2.getMonth() - date1.getMonth();
    let totalMonths = years * 12 + months;

    // Adjust if end day is less than start day (Excel style)
    if (date2.getDate() < date1.getDate()) {
      totalMonths--;
    }

    return totalMonths;
  }
  const calculateGoalNeed = (record, data) => {
    const GoalNeedToday = data["Dollar Amount Needed"]
      ? data["Dollar Amount Needed"]
      : 0;
    // const GoalInflationRate = data["Inflation rate for this goal"]
    //   ? data["Inflation rate for this goal"] / 100
    //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
    const GoalInflationRate = 10;
    const GoalDate = data["Goal Date"]
      ? new Date(data["Goal Date"])
      : new Date();
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    // Calculate the number of days between GoalDate and todaysDate
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);
    // Calculate the formula
    // const result = GoalNeedToday * Math.pow(1 + (GoalInflationRate / 365), 365 * (daysBetween / 365) - NumberofMonths);
    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );
    console.log("result", result);
    return `${
      "$" +
      result
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }`;
  };
  const calculateGoalNeedAfterAsset = (record, data, amortization) => {
    const assetName = record["Name of Asset"];
    const amortizationofRecord = amortization && amortization[assetName];
    const GoalDate = data["Goal Date"]
      ? new Date(data["Goal Date"])
      : new Date();
    console.log("amortizationofRecord", amortizationofRecord);
    const loanPaybaleForAsset = amortizationofRecord
      ? amortizationofRecord
          .filter((record) => new Date(record.date) <= GoalDate)
          .reduce((total, record) => {
            const payable = record.valuepayable;
            return total + (typeof payable === "number" ? payable : 0);
          }, 0)
      : 0;
    const assetValueToday = record["Monetary Value"]
      ? +record["Monetary Value"]
      : 0;
    // const taxabilityonAsset = record["Monetary Value"]
    //   ? +record["Monetary Value"] * 0.25
    //   : 0;
    const taxabilityonAsset = record["Taxes"] ? +record["Taxes"] : 0;
    const rateofReturn = record["Static"] ? +record["Static"] : 0;
    const startDate = record["Cost Basis Date"]
      ? +record["Cost Basis Date"]
      : new Date();
    // const costToSell = record["Actual Value at Sale Date"]
    //   ? +record["Actual Value at Sale Date"] * 0.1
    //   : 0;
    const costToSell = record["Commission on Sale"]
      ? +record["Commission on Sale"]
      : 0;
    const liabilityPayOff = record["Total Liabilities"]
      ? record["Total Liabilities"]
      : 0;
    const transactionCost = record["Other Transaction Costs"]
      ? record["Other Transaction Costs"]
      : 0;
    const totalInHand = (
      assetValueToday -
      taxabilityonAsset -
      costToSell -
      liabilityPayOff -
      transactionCost -
      loanPaybaleForAsset
    ).toFixed(2);
    // let totalInHand=calculateAssetValueonGoalDate(record, data);
    const GoalNeedToday = data["Dollar Amount Needed"]
      ? data["Dollar Amount Needed"]
      : 0;
    // const GoalInflationRate = data["Inflation rate for this goal"]
    //   ? data["Inflation rate for this goal"] / 100
    //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
    const GoalInflationRate = 10;
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    // Calculate the number of days between GoalDate and todaysDate
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);
    // Calculate the formula
    // const result = GoalNeedToday * Math.pow(1 + (GoalInflationRate / 365), 365 * (daysBetween / 365) - NumberofMonths);
    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );
    console.log("resultInHand", result, totalInHand, result - totalInHand);
    if (result === 0) {
      return result.toFixed(2);
    } else {
      return (totalInHand - result).toFixed(2);
    }
  };
  const calculateLoanPayable = (record, amortization) => {
    const assetName = record["Name of Asset"];
    const amortizationofRecord = amortization && amortization[assetName];
    const GoalDate = data["Goal Date"]
      ? new Date(data["Goal Date"])
      : new Date();
    const loanPaybaleForAsset = amortizationofRecord
      ? amortizationofRecord
          .filter((record) => new Date(record.date) <= GoalDate)
          .reduce((total, record) => {
            const payable = record.valuepayable;
            return total + (typeof payable === "number" ? payable : 0);
          }, 0)
      : 0;
    return `${"$" + loanPaybaleForAsset.toFixed(2)}`;
  };
  const calculateAssetValueonGoalDate = (record, amortization) => {
    const assetName = record["Name of Asset"];
    const amortizationofRecord = amortization && amortization[assetName];
    const GoalDate = data["Goal Date"]
      ? new Date(data["Goal Date"])
      : new Date();
    console.log("amortizationofRecord", amortizationofRecord);
    // const loanPaybaleForAsset = amortizationofRecord
    //   ? amortizationofRecord.reduce((total, record) => {
    //       const payable = record.valuepayable;
    //       return total + (typeof payable === "number" ? payable : 0);
    //     }, 0)
    //   : 0;
    const loanPaybaleForAsset = amortizationofRecord
      ? amortizationofRecord
          .filter((record) => new Date(record.date) <= GoalDate)
          .reduce((total, record) => {
            const payable = record.valuepayable;
            return total + (typeof payable === "number" ? payable : 0);
          }, 0)
      : 0;
    const assetValueToday = record["Monetary Value"]
      ? +record["Monetary Value"]
      : 0;
    // const taxabilityonAsset = record["Monetary Value"]
    //   ? +record["Monetary Value"] * 0.25
    //   : 0;
    const taxabilityonAsset = record["Taxes"] ? +record["Taxes"] : 0;
    const rateofReturn = record["Static"] ? +record["Static"] : 0;
    const startDate = record["Cost Basis Date"]
      ? +record["Cost Basis Date"]
      : new Date();
    // const costToSell = record["Actual Value at Sale Date"]
    //   ? +record["Actual Value at Sale Date"] * 0.1
    //   : 0;
    const costToSell = record["Commission on Sale"]
      ? +record["Commission on Sale"]
      : 0;
    const liabilityPayOff = record["Total Liabilities"]
      ? record["Total Liabilities"]
      : 0;
    const transactionCost = record["Other Transaction Costs"]
      ? record["Other Transaction Costs"]
      : 0;
    const equityForGoal = (
      assetValueToday -
      taxabilityonAsset -
      costToSell -
      liabilityPayOff -
      transactionCost -
      loanPaybaleForAsset
    ).toFixed(2);
    console.log("equityForGoalNew", equityForGoal);
    return `${"$" + parseFloat(equityForGoal).toFixed(2)}`;
  };
  const calculateGoalRequirements = (record, data, amortization) => {
    const assetName = record["Name of Asset"];
    const amortizationofRecord = amortization && amortization[assetName];
    const todaysDate = new Date();
    const GoalDate = data["Goal Date"]
      ? new Date(data["Goal Date"])
      : new Date();

    // loan paybale till goal date against asset
    // const loanPaybaleForAsset = amortizationofRecord
    //   ? amortizationofRecord
    //       .filter((record) => new Date(record.date) <= GoalDate)
    //       .reduce((total, record) => {
    //         const payable = record.valuepayable;
    //         return total + (typeof payable === "number" ? payable : 0);
    //       }, 0)
    //   : 0;

    // loan paybale after goal date against asset
      const loanPaybaleForAsset = amortizationofRecord
      ? amortizationofRecord
          .filter((record) => new Date(record.date) >= GoalDate)
          .reduce((total, record) => {
            const payable = record.valuepayable;
            return total + (typeof payable === "number" ? payable : 0);
          }, 0)
      : 0;
      console.log("loanPaybaleForAsset",loanPaybaleForAsset,amortization)
    const assetValueToday = record["Monetary Value"]
      ? +record["Monetary Value"]
      : 0;
    const taxabilityonAsset = record["Taxes"] ? +record["Taxes"] : 0;
    const rateofReturn = record["Static"] ? +record["Static"] : 0;
    const startDate = record["Cost Basis Date"]
      ? +record["Cost Basis Date"]
      : new Date();
    const costToSell = record["Commission on Sale"]
      ? +record["Commission on Sale"]
      : 0;
    const liabilityPayOff = record["Total Liabilities"]
      ? record["Total Liabilities"]
      : 0;
    const transactionCost = record["Other Transaction Costs"]
      ? record["Other Transaction Costs"]
      : 0;
    const equityForGoal = (
      assetValueToday -
      taxabilityonAsset -
      costToSell -
      // liabilityPayOff -
      transactionCost -
      loanPaybaleForAsset
    ).toFixed(2);

    const GoalNeedToday = data["Dollar Amount Needed"]
      ? data["Dollar Amount Needed"]
      : 0;
    // const GoalInflationRate = data["Inflation rate for this goal"]
    //   ? data["Inflation rate for this goal"] / 100
    //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
      const GoalInflationRate = 10;
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );

    const formattedEquityForGoal = parseFloat(equityForGoal)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const formattedResult = result
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const needAfterAsset =
      result === 0 ? result.toFixed(2) : (equityForGoal - result).toFixed(2);
    const formattedLoanPayable = loanPaybaleForAsset
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const monthlySavingRequired=NumberofMonths > 0 ? +needAfterAsset/NumberofMonths : 0;
    console.log("monthlySavingRequired",monthlySavingRequired,needAfterAsset,NumberofMonths)
    return {
      equityForGoal: `$${formattedEquityForGoal}`,
      goalNeedToday: `$${formattedResult}`,
      needAfterAsset: `$${needAfterAsset
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      loanPayableForAsset: `$${formattedLoanPayable}`,
      monthlySavingRequired:monthlySavingRequired,
      newAssetCreated:needAfterAsset,
    };
  };

  // useEffect(() => {
  //   if (attributeValues && assetsList && assetsList.length > 0) {
  //     if (data["Goal Date"] !== attributeValues["Goal Date"]) {
  //       console.log("rowwwwwAll liquid", dataSource, assetsList);
  
  //       // Initialize the array to hold the new data objects
  //       let assetsToCreate = [];
  
  //       dataSource &&
  //         dataSource.forEach((row) => {
  //           const asset = assetsList.find((asset) => asset.id === row.asset_id);
  //           const amountUsed =
  //             data["Amount to use for this goal"] &&
  //             Array.isArray(data["Amount to use for this goal"])
  //               ? data["Amount to use for this goal"].reduce(
  //                   (acc, curr) => acc + curr,
  //                   0
  //                 )
  //               : 0;

  //           if (asset) {
  //             let result = calculateGoalRequirements(
  //               asset,
  //               data,
  //               transformedData
  //             );
  //             const newData = {
  //               key: row.key,
  //               asset_id: row.asset_id,
  //               Priority: count,
  //               Asset: row && row["Name of Asset"] ? row["Name of Asset"] : null,
  //               "Value of Asset at goal date":
  //                 asset && asset["Monetary Value"]
  //                   ? asset["Monetary Value"]
  //                   : null,
  //               "Loan value to goal date":
  //                 result && result.loanPayableForAsset
  //                   ? parseFloat(
  //                       result.loanPayableForAsset.replace(/[^0-9.-]+/g, "")
  //                     )
  //                   : null,
  //               "Amount to use for this goal":
  //                 result && result.equityForGoal
  //                   ? parseFloat(
  //                       result.equityForGoal.replace(/[^0-9.-]+/g, "")
  //                     ) >
  //                     (result.goalNeedToday &&
  //                       result.goalNeedToday.replace(/[^0-9.-]+/g, ""))
  //                     ? parseFloat(
  //                         result.goalNeedToday.replace(/[^0-9.-]+/g, "")
  //                       ) 
  //                     : parseFloat(
  //                         result.equityForGoal.replace(/[^0-9.-]+/g, "")
  //                       )
  //                   : 0,
  //               Taxes: row && row["Taxes"] ? row["Taxes"] : null,
  //               "Net after tax applied to goals":
  //                 totalAmountToUse && totalAmountToUse ? totalAmountToUse : null,
  //             };
  
  //             // Push the new data object into the array
  //             assetsToCreate.push(newData);
  //             console.log("Asset with resultAll", result);
  //           } else {
  //             console.warn(`Asset with id ${row.asset_id} not found.`);
  //           }
  //         });
  //       console.log("assetsToCreate",assetsToCreate)
  //       // After the loop, pass the assetsToCreate array to cbFormChange
  //       if (assetsToCreate.length > 0) {
  //         cbFormChange(assetsToCreate);
  //       }
  //     }
  //   }
  // }, [attributeValues, assetsList]);
  
  useEffect(() => {
    getAllDetails(currentPage);
  }, [currentPage]);
  const getAllDetails = async (currentPage) => {
    // await getLiabilityList(currentPage);
    await getAssetsList(currentPage);
  };
  // useEffect(() => {
  //   if (!liabilities) {
  //     console.error("Missing required data.");
  //     return;
  //   }
  //   const myData =
  //     liabilities &&
  //     liabilities.sort(
  //       (a, b) => a["Initial Loan Amount"] - b["Initial Loan Amount"]
  //     );
  //   if (!myData || myData.length === 0) {
  //     console.error("No liabilities data.");
  //     return;
  //   }
  //   let temp = {};
  //   let arrData = [];
  //   let keys = [
  //     "Month", // Default key, can be adjusted based on frequency
  //     "One-time Funding",
  //     "Snowball",
  //     ...myData.map((item) => item["Nickname of Liabilities"]),
  //     "End Balance",
  //   ];
  //   temp["header"] = keys;
  //   const arr = myData.map((item) => item["Nickname of Liabilities"]);
  //   const data = {};
  //   myData.forEach((item) => {
  //     const nickname = item["Nickname of Liabilities"];
  //     let monthlyPayment = item["Monthly Payment"] || 0;
  //     if (typeof monthlyPayment === "string") {
  //       monthlyPayment = monthlyPayment.replace(/[$,]/g, "").trim();
  //     }
  //     monthlyPayment = parseFloat(monthlyPayment);
  //     if (isNaN(monthlyPayment)) {
  //       monthlyPayment = 0;
  //     }
  //     let initialLoanAmount = item["Initial Loan Amount"] || 0;
  //     if (typeof initialLoanAmount === "string") {
  //       initialLoanAmount = initialLoanAmount.replace(/[$,]/g, "").trim();
  //     }
  //     initialLoanAmount = parseFloat(initialLoanAmount);
  //     if (isNaN(initialLoanAmount)) {
  //       initialLoanAmount = 0;
  //     }
  //     let interestRate = item["Interest Rate"] || 0;
  //     if (typeof interestRate === "string") {
  //       interestRate = interestRate.replace(/[$,]/g, "").trim();
  //     }
  //     interestRate = parseFloat(interestRate) / 100;
  //     if (isNaN(interestRate)) {
  //       interestRate = 0;
  //     }
  //     const startDate = item["Start Date"] ? new Date(item["Start Date"]) : new Date();
  //     data[nickname] = {
  //       total: 0,
  //       data: [],
  //       ILA: initialLoanAmount,
  //       InterestRate: interestRate,
  //       minimum: monthlyPayment,
  //       active: true,
  //       startDate: startDate,
  //     };
  //   });
  //   let monthlyPayment =
  //     snowball +
  //     (myData &&
  //       myData.reduce((total, item) => {
  //         let payment = item["Monthly Payment"];
  //         if (typeof payment === "string") {
  //           payment = payment.replace(/[$,]/g, "").trim();
  //         }
  //         const parsedPayment = parseFloat(payment);
  //         return total + (isNaN(parsedPayment) ? 0 : parsedPayment);
  //       }, 0));
  //   let endBalance =
  //     myData &&
  //     myData.reduce((total, item) => {
  //       let payment = item["Initial Loan Amount"];
  //       if (typeof payment === "string") {
  //         payment = payment.replace(/[$,]/g, "").trim();
  //       }
  //       const parsedPayment = parseFloat(payment);
  //       return total + (isNaN(parsedPayment) ? 0 : parsedPayment);
  //     }, 0);
  //   let i = 0;
  //   let principalPaidSum = 0;
  //   let startDate = new Date();
  //   let globalArr = [];
  //   let newEndBal = endBalance;
  //   let otpData = {};
  //   // oneTimeFunding &&
  //   //     oneTimeFunding.forEach(
  //   //         (val) => (otpData[moment(val.date).format("MM-DD-YYYY")] = val.payment)
  //   //     );
  //   let iterationCount = 0;
  //   const maxIterations = 2000; // Set a maximum iteration limit
  //   while (
  //     Array.isArray(arr) &&
  //     arr &&
  //     arr.length > 0 &&
  //     iterationCount < maxIterations
  //   ) {

  //     startDate.setMonth(startDate.getMonth() + 1);
  //     i++;
  //     let obj = {
  //       week: moment(startDate).format("MM-DD-YYYY"), // Adjust format based on frequency
  //     };
  //     console.log("obj.week", obj.week, otpData);
  //     // Parse the dates
  //     let weekDate = obj.week && new Date(obj.week);
  //     // Extract month and year
  //     let weekMonth = weekDate && weekDate.getMonth(); // 0-11 (January is 0, December is 11)
  //     let weekYear = weekDate && weekDate.getFullYear();
  //     let oneTimeMonthFunding = 0;
  //     // Iterate through the otpData keys
  //     for (let dateStr in otpData) {
  //       let otpDate = new Date(dateStr);
  //       let otpMonth = otpDate && otpDate.getMonth();
  //       let otpYear = otpDate && otpDate.getFullYear();
  //       // Compare month and year
  //       if (weekMonth === otpMonth && weekYear === otpYear) {
  //         oneTimeMonthFunding = otpData[dateStr];
  //         break; // Break out of the loop once a match is found
  //       }
  //     }

  //     // let oneTimeMonthFunding = otpData[obj.week] || 0;
  //     let snowball =
  //       monthlyPayment -
  //       Object.values(data).reduce(
  //         (a, b) => a + (b.active && b.minimum) || 0,
  //         0
  //       ) +
  //       oneTimeMonthFunding;
  //     let newsnowball = snowball;
  //     let principalPaidInIteration = 0;
  //     console.log("otpData",arr)
  //     arr.forEach((e, index) => {
  //       let element = data[e];
  //       let monthlyInterestRate = element.InterestRate / 12;
  //       let interestRatePaid = element.ILA * monthlyInterestRate;
  //       let principal;
  //       if (element.ILA <= element.minimum + newsnowball) {
  //         element.active = false;
  //         principal = element.ILA;
  //         let totalPaid = interestRatePaid + principal;
  //         snowball =
  //           Math.round((element.minimum + snowball - totalPaid) * 100) / 100;
  //         newsnowball = snowball;
  //       } else {
  //         principal = element.minimum + (newsnowball || 0) - interestRatePaid;
  //         if (newsnowball > 0) {
  //           newsnowball = 0;
  //         }
  //       }
  //       obj[e] = Math.round((interestRatePaid + principal) * 100) / 100;
  //       element.total += Math.round(interestRatePaid * 100) / 100;
  //       element.ILA -= Math.round(principal * 100) / 100;
  //       element.data.push({
  //         week: new Date(startDate), // Date adjustment logic
  //         totalPaid: Math.round((interestRatePaid + principal) * 100) / 100,
  //         snowball,
  //         endBalance: Math.round((endBalance - principalPaidSum) * 100) / 100,
  //       });
  //       data[e] = { ...element, data: [...element.data] };
  //       principalPaidInIteration += Math.round(principal * 100) / 100;
  //     });
  //     let liabilities = Object.keys(data);
  //     liabilities.forEach((l) => {
  //       obj[l] = (!obj[l] && "") || obj[l];
  //     });
  //     principalPaidSum += principalPaidInIteration;
  //     newEndBal -= principalPaidInIteration;
  //     obj["endBalance"] = Math.round(newEndBal * 100) / 100;
  //     obj["snowball"] = Math.round(snowball * 100) / 100;
  //     obj["oneTimeFunding"] = oneTimeMonthFunding;
  //     globalArr.push({ ...obj });
  //     arr.forEach((element, index) => {
  //       if (!data[element].active) arr.splice(index, 1);
  //     });
  //     iterationCount++; // Increment iteration count
  //   }
  //   if (iterationCount >= maxIterations) {
  //     console.error("Exceeded maximum iteration limit. Terminating loop.");
  //     return;
  //   }
  //   globalArr &&
  //     globalArr.map((input, index) => {
  //       let obj = {};
  //       Object.keys(data).map((e) => (obj[e] = input[e]));
  //       let tableData = {
  //         week: input.week, // Changed from "month" to "week"
  //         onetime: input["oneTimeFunding"],
  //         snowball: input.snowball,
  //         ...obj,
  //         endBalance: input.endBalance,
  //       };
  //       arrData.push(Object.values(tableData));
  //     });
  //   console.log("globalArr", globalArr, arrData, temp);
  //   temp["data"] = arrData;
  //   setDataRes(temp);
  // }, [liabilities]);

  // useEffect(()=>{
  //   let paymentResult=calculatePayments(liabilities)
  //   // let paybaleAmount= paymentResult && calculateTotalValuePayable(paymentResult);
  //   console.log("paymentResult",paymentResult);
  // },[liabilities])

  function calculateMonetoryValue(asset) {
    const currentDate =data["Goal Date"] ? new Date(data["Goal Date"]) : new Date();
    let Start = (asset["Cost Basis Date"] && new Date(asset["Cost Basis Date"])) || new Date();
    const differenceInMs = currentDate.getTime() - Start.getTime();
    const daysDifference = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
    let totalDays = daysDifference / 365;
  
    let Cost = +asset["Cost Basis"] || 0;
    let ReturnRate = +asset["Static"] || 0;
    let decimalValue = ReturnRate ? ReturnRate / 100 : 0;
    const amount = 1 + decimalValue / 365;
    let power = Math.pow(amount, totalDays * 365);
    const estimateDiff = Cost * power;
  
    if (estimateDiff > 0 && !isNaN(estimateDiff)) {
      return parseFloat(estimateDiff).toFixed(2);
    } else {
      return 0;
    }
  }
  

  function calculateTotalValuePayable(data) {
    const totals = {};

    // Iterate through each liability type
    for (const [liability, payments] of Object.entries(data)) {
        // Calculate total value payable for each liability
        const totalValuePayable = payments.reduce((sum, payment) => sum + payment.valuepayable, 0);
        // Store the total in the totals object
        totals[liability] = totalValuePayable;
    }

    return totals;
  }
  function calculatePayments(liabilities) {
    if (!liabilities) {
        console.error("Missing required data.");
        return {};
    }

    const result = {};
    const maxIterations = 2000; // Set a maximum iteration limit

    liabilities.forEach((item) => {
        const nickname = item["Nickname of Liabilities"];
        let monthlyPayment = item["Monthly Payment"] || 0;
        let initialLoanAmount = item["Initial Loan Amount"] || 0;
        let startDate = item["Start Date"] ? new Date(item["Start Date"]) : new Date();
        let endDate = item["Maturity Date"] ? new Date(item["Maturity Date"]) : new Date();
        let interestRate = item["Interest Rate"] || 0;

        // Check if startDate and endDate are valid
        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            console.error(`Invalid dates for liability: ${nickname}`);
            return;
        }

        if (typeof monthlyPayment === "string") {
            monthlyPayment = parseFloat(monthlyPayment.replace(/[$,]/g, "").trim());
        }

        if (typeof initialLoanAmount === "string") {
            initialLoanAmount = parseFloat(initialLoanAmount.replace(/[$,]/g, "").trim());
        }

        if (typeof interestRate === "string") {
            interestRate = parseFloat(interestRate.replace(/[%]/g, "").trim()) / 100;
        }

        if (isNaN(monthlyPayment) || isNaN(initialLoanAmount) || isNaN(interestRate)) {
            console.error(`Invalid data for liability: ${nickname}`);
            return;
        }

        const payments = [];
        let currentDate = new Date(startDate);
        const monthlyInterestRate = interestRate / 12;
        let remainingBalance = initialLoanAmount;
        let iterationCount = 0; // Initialize iteration counter

        // Calculate total number of months until the end date
        const numberOfMonths = Math.max(
            Math.ceil(((endDate - startDate) / (1000 * 60 * 60 * 24 * 30))),
            0
        );
        // console.log("numberOfMonths",numberOfMonths)
        // Calculate total payable amount based on monthly payments
        const totalPayable = monthlyPayment * numberOfMonths;
        // console.log(`Total Payable for ${nickname}: ${totalPayable}`);

        while (currentDate <= endDate && iterationCount < maxIterations) {

            const interestPaid = remainingBalance * monthlyInterestRate;
            const principalPaid = Math.min(monthlyPayment - interestPaid, remainingBalance); // Cap principal payment to remaining balance
            const valuePayable = Math.round((interestPaid + principalPaid) * 100) / 100;
            // console.log(`Date Till pay for ${nickname}: ${iterationCount}, ${principalPaid} ${interestPaid}`);

            // Only add payment if the value payable is greater than zero
            if (valuePayable > 0) {
                payments.push({
                    date: moment(currentDate).format("MM-DD-YYYY"), // Format as MM-DD-YYYY
                    valuepayable: valuePayable
                });
            }

            remainingBalance -= principalPaid;

            // Ensure remaining balance is not negative
            if (remainingBalance <= 0) {
                remainingBalance = 0;
            }

            // Increment month
            currentDate.setMonth(currentDate.getMonth() + 1);

            // Check if the date is valid after increment
            if (isNaN(currentDate.getTime())) {
                console.error(`Invalid date after increment for liability: ${nickname}`);
                break;
            }

            iterationCount++; // Increment iteration counter
        }

        // If there are payments, ensure the total payments do not exceed the total payable
        if (payments.length > 0) {
            const totalPaymentsMade = payments.reduce((total, payment) => total + payment.valuepayable, 0);
            // console.log(`Total Payments Made for ${nickname}: ${totalPaymentsMade}`);

            if (totalPaymentsMade > totalPayable) {
                console.warn(`Total payments made exceed total payable for liability: ${nickname}`);
            }
        }

        result[nickname] = payments;
    });

    return result;
  }

  console.log("setDataRes", dataRes);
  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      // liquid Asset

      // const filteredAssets = datares.records.filter(
      //   (record) =>
      //     record.hasOwnProperty("This Asset is Liquid") &&
      //     record["This Asset is Liquid"] === true
      // );

      // illiquid Asset

      const filteredAssets = datares.records.filter(
        (record) =>
          !record.hasOwnProperty("This Asset is Liquid") ||
          record["This Asset is Liquid"] === false
      );
      const assetsWithMonetaryValue = filteredAssets && filteredAssets.map((asset) => ({
        ...asset,
        "Monetary Value": +calculateMonetoryValue(asset),
      }));
      // console.log("assetsWithMonetaryValue",assetsWithMonetaryValue,filteredAssets)
      setAssetsList(assetsWithMonetaryValue);
      // setAssetsList(filteredAssets);
      //  setAssetsList(datares.records);
    }
    if (datares && datares.pagination) {
      setTotal(datares.pagination.total);
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };
  function transformData(dataRes) {
    const result = {};

    // Start from the 4th header (index 3) and process each header
    for (let i = 3; i < dataRes.header.length; i++) {
      const headerName = dataRes.header[i];
      result[headerName] = [];

      dataRes.data.forEach((row) => {
        result[headerName].push({
          date: row[0], // Use the first element as date
          valuepayable: row[i], // Use the current header's index for valuepayable
        });
      });
    }
    console.log("transaformdata", result);
    return result;
  }
console.log("AssetdataSource",dataSource)
  // const transformedData = dataRes && transformData(dataRes);
  const transformedData =liabilities && calculatePayments(liabilities)
  console.log("transformedData", transformedData);
  const colsNonLiquidAssets = [
    {
      title: "Asset",
      dataIndex: "Name of Asset",
      sorter: (a, b) => a["Name of Asset"] > b["Name of Asset"],
      render: (record) => (record ? record : "--------"),
    },
    {
      // title: "Equity on Goal Date",
      title: "Amount Available on Goal Date",
      render: (fileName, record) => {
        let result =
          record && calculateGoalRequirements(record, data, transformedData);
        return result && result.equityForGoal && result.equityForGoal ? (
          <div>{result.equityForGoal}</div>
        ) : (
          "N/A"
        );
      },
      // render: (record) =>
      //   record
      //     ? calculateAssetValueonGoalDate(record, transformedData)
      //     : "--------",
    },
    {
      title: "Value on Goal Date",
      dataIndex: "Monetary Value",
      sorter: (a, b) => a["Monetary Value"] - b["Monetary Value"],
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + parseFloat(record).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
  
    {
      title: "Commission on Sale",
      dataIndex: "Commission on Sale",
      sorter: (a, b) => a["Commission on Sale"] - b["Commission on Sale"],
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Other Transaction Costs",
      dataIndex: "Other Transaction Costs",
      sorter: (a, b) =>
        a["Other Transaction Costs"] - b["Other Transaction Costs"],
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Taxes Paid on Sale Date",
      dataIndex: "Taxes",
      sorter: (a, b) => a["Taxes"] - b["Taxes"],
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    // {
    //   title: "Total Liabilities",
    //   dataIndex: "Total Liabilities",
    //   sorter: (a, b) => a["Name of Asset"] > b["Name of Asset"],
    //   render: (record) =>
    //     record
    //       ? !isNaN(record)
    //         ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
    //         : "N/A"
    //       : "N/A",
    // },
    {
      title: "Total Liabilities",
      // dataIndex: "Name of Asset",
      // sorter: (a, b) => a["Name of Asset"] > b["Name of Asset"],
      render: (fileName, record) => {
        let result =
          record && calculateGoalRequirements(record, data, transformedData);
        return result &&
          result.loanPayableForAsset &&
          result.loanPayableForAsset ? (
          <div>{result.loanPayableForAsset}</div>
        ) : (
          "N/A"
        );
      },
      // render: (record) =>
      //   record ? calculateLoanPayable(record, transformedData) : "N/A",
    },
    // {
    //   title: "Total Goal Need at Goal date",
    //   // dataIndex: "Monetary Value",
    //   // sorter: (a, b) => a["Monetary Value"] - b["Monetary Value"],
    //   render: (fileName, record) => {
    //     let result =
    //       record && calculateGoalRequirements(record, data, transformedData);
    //     return result && result.goalNeedToday && result.goalNeedToday ? (
    //       <div>{result.goalNeedToday}</div>
    //     ) : (
    //       "N/A"
    //     );
    //   },
    //   // render: (record) =>
    //   //   record ? data && calculateGoalNeed(record, data) : "--------",
    // },
    // {
    //   title: "Need After Asset Assignment",
    //   // render: (record) =>
    //   //   record
    //   //     ? calculateGoalNeedAfterAsset(record, data, transformedData)
    //   //     : "--------",
    //   render: (fileName, record) => {
    //     let result =
    //       record && calculateGoalRequirements(record, data, transformedData);
    //     return result && result.needAfterAsset && result.needAfterAsset ? (
    //       <div>{result.needAfterAsset}</div>
    //     ) : (
    //       "N/A"
    //     );
    //   },
    // },
    // {
    //   title: "Monthly Savings Required",
    //   render: (fileName, record) => {
    //     let result =
    //       record && calculateGoalRequirements(record, data, transformedData);
    //     return result &&
    //       result.monthlySavingRequired &&
    //       result.monthlySavingRequired ? (
    //       <div>{`${"$" + (result.monthlySavingRequired).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}</div>
    //     ) : (
    //       "N/A"
    //     );
    //   },
    //   // render: (record) =>
    //   //   record ? calculateLoanPayable(record, transformedData) : "N/A",
    // },
    // {
    //   title: "New Asset Created",
    //   render: (fileName, record) => {
    //     let result =
    //       record && calculateGoalRequirements(record, data, transformedData);
    //     return result &&
    //       result.newAssetCreated &&
    //       result.newAssetCreated < 0 ? (
    //       <div>{`${"$" + (-1*result.newAssetCreated).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}</div>
    //     ) : (
    //       "N/A"
    //     );
    //   },
    // },
    {
      title: "SELL THIS ASSET",
      render: (record, index) => {
        let isDisabled =dataSource && dataSource.some(item => item.assetId === record.id)
        return (
          <React.Fragment>
            <button
              className="saveStatusbutton"
              // disabled={isDisabled ? true : false}
              style={{
                width: "100%",
                fontWeight: "bold",
                background: `${isDisabled ? "#E13C25" : ""}`,
                // cursor:`${isDisabled ? "not-allowed" : ""}`,
              }}
              onClick={async (e) => {
                e.preventDefault();
                if(isDisabled){
                  handleDelete(record)
                }
                else{
                  handleAdd(record);
                }
              }}
            >
            {isDisabled ? "Selected" : "Select"}
            </button>
          </React.Fragment>
        );
      },
    },
  ];
  return (
    <div className="assetAssignTable" style={{position:"relative"}}>
      <div className="goalSubFormTable">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h3 className="incomecardheading">
          Illiquid Assets
        </h3>
        <ToolTipCreator name={"Goals_Illiquid_Assets"}/>
        </div>
        <Table
          columns={colsNonLiquidAssets}
          dataSource={assetsList && assetsList}
          pagination={{
            total: totalPages * 10, // Assuming 10 items per page
            current: currentPage,
            onChange: (page) => {
              setCurrentPage(page);
            },
            pageSize: 10, // Number of items per page
          }}
        />
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
